// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import React from 'react'
import { number, string } from 'prop-types'
import { useBooleanToggle } from 'hooks'
import ModalWrapper from './ModalWrapper'

// NOTE - we are using our own instance of <Modal /> here and not the global ModalContext.
// because we need to be able to support this modal from within another modal.

// this is a trigger to the Contact Details Modal.
// it takes a contactId from the parent and
// when clicked, opens a modal which will fetch the contact's
// details information to be displayed in the UI.

const ContactDetails = ({ contactId, idRoot }) => {
  const [isOpen, toggleIsOpen] = useBooleanToggle()

  // NOTE - the wrapping div here is needed so we can properly control the propagation of click events on
  // the Contact Details modal and prevent that event from bubbling up to the parent modal. When this happens,
  // react-modal interprets it as a click on the parent element to this trigger.
  // IE. it makes the contact lookup apply its row click handler from within the contact details modal
  // and closes both the contact lookup and details modals at the same time.
  return (
    <div onClick={e => e.stopPropagation()}>
      <i
        className={'fa fa-address-card'}
        id={`${idRoot}-trigger`}
        onClick={toggleIsOpen} />
      {
        isOpen &&
        <ModalWrapper
          closeModal={toggleIsOpen}
          contactId={contactId}
          idRoot={idRoot} />
      }
    </div>
  )
}

ContactDetails.propTypes = {
  contactId: number.isRequired,
  idRoot: string.isRequired,
}

export default ContactDetails
